import { Building2 } from "lucide-react";
import { scrollTo } from "./Nav";
import ManagePlan from "./ManagePlan";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 py-14" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="w-8 h-8 rounded-full bg-terracotta flex items-center justify-center">
              <Building2 className="w-4 h-4 text-charcoal" strokeWidth={2.4} />
            </span>
            <span className="font-display font-bold text-parchment">Doorstep Disposal <span className="text-terracotta">Co.</span></span>
          </div>
          <p className="mt-4 text-xs text-dim max-w-sm leading-relaxed">
            Doorstep valet trash collection for our 500-unit community. Windows: 6:00–9:00 AM and 6:00–9:00 PM, daily.
            Fully insured under a $1M/$2M General Liability Policy.
          </p>
        </div>
        <div className="flex flex-col items-start md:items-end gap-3">
          <div className="flex gap-6">
            <button data-testid="footer-pricing-link" onClick={() => scrollTo("#pricing")} className="text-xs text-mist hover:text-parchment transition-colors">Pricing</button>
            <button data-testid="footer-rules-link" onClick={() => scrollTo("#service-rules")} className="text-xs text-mist hover:text-parchment transition-colors">Rules</button>
            <ManagePlan className="text-xs text-mist hover:text-parchment transition-colors" />
            <a href="/admin" data-testid="footer-admin-link" className="text-xs text-mist hover:text-parchment transition-colors">Admin</a>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-dim">
            Payments in Stripe test mode · No real charges
          </p>
        </div>
      </div>
    </footer>
  );
}
